import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input, Alert } from 'reactstrap';
import fetchApi from 'components/Api/Actions';

const AddAccount = ({ isOpen, toggle, addItemToState, url, user_id, refreshItems }) => {
    const [accounts, setAccounts] = useState([]);
    const [roles, setRoles] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState('');
    const [selectedRole, setSelectedRole] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchAccounts = async () => {
            const accountsData = await fetchApi('account/all', { method: 'GET' });
            if (accountsData) {
                setAccounts(accountsData);
            } else {
                console.log('Failed to fetch accounts');
            }
        };

        const fetchRoles = async () => {
            const rolesData = await fetchApi('roles', { method: 'GET' });
            if (rolesData) {
                setRoles(rolesData);
            } else {
                console.log('Failed to fetch roles');
            }
        };

        fetchAccounts();
        fetchRoles();
    }, []);

    const handleSave = async () => {
        if (!selectedAccount || !selectedRole) {
            setError('Both account and role are required.');
            return;
        }
        const options = {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ account_id: selectedAccount, role_id: selectedRole, user_id: user_id }),
        };
        const item = await fetchApi('user-account/assign-user-to-account', options);
        if (item) {
            refreshItems();
            toggle();
        } else {
            refreshItems();
            console.log('Failed to save accounts');
            toggle();
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>Add Account</ModalHeader>
            <ModalBody>
                {error && <Alert color="danger">{error}</Alert>}
                <Form>
                    <FormGroup>
                        <Label for="accountSelect">Select Account</Label>
                        <Input
                            type="select"
                            name="account"
                            id="accountSelect"
                            value={selectedAccount}
                            onChange={(e) => setSelectedAccount(e.target.value)}
                            required
                        >
                            <option value="">Select an account</option>
                            {accounts.map((account) => (
                                <option key={account.id} value={account.id}>
                                    {account.name}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>
                    <FormGroup>
                        <Label for="roleSelect">Select Role</Label>
                        <Input
                            type="select"
                            name="role"
                            id="roleSelect"
                            value={selectedRole}
                            onChange={(e) => setSelectedRole(e.target.value)}
                            required
                        >
                            <option value="">Select a role</option>
                            {roles.map((role) => (
                                <option key={role.id} value={role.id}>
                                    {role.name}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleSave}>Save</Button>
                <Button color="secondary" onClick={toggle}>Cancel</Button>
            </ModalFooter>
        </Modal>
    );
};

export default AddAccount;